import type { FC } from 'react';

interface HeaderProps {
  title: string;
  subtitle?: string;
}

export const Header: FC<HeaderProps> = ({ title, subtitle }) => {
  return (
    <header className="max-w-4xl mx-auto mb-8">
      {title && (
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 text-center">
          {title}
        </h1>
      )}
      {subtitle && subtitle.trim() && (
        <p className="text-center text-gray-600 mt-2">
          {subtitle}
        </p>
      )}
    </header>
  );
};
